function splitSentenceToLines(sentence, lineLength) {
  const words = sentence.split(" ");
  let currentLine = "";
  const result = [];

  for (const word of words) {
    if (currentLine.length + word.length + 1 <= lineLength) {
      // Add the word to the current line
      currentLine += (currentLine.length > 0 ? " " : "") + word;
    } else {
      // Start a new line with the current word
      var text = currentLine.split(" ");
      result.push(text.reverse().join(" ") + "\n");
      currentLine = word;
    }
  }

  // Add the last line
  if (currentLine.length > 0) {
    var text = currentLine.split(" ");
    result.push(text.reverse().join(" ") + "\n");
    // result.push(currentLine + "\n");
  }
  // console.log(result.reverse().join("\n"));

  return result;
}

export function handleArabicCharacters(message) {
  let arabic = [];
  let english = [];

  // var regex = new RegExp(
  //   "[\u0600-\u06ff]|[\u0750-\u077f]|[\ufb50-\ufc3f]|[\ufe70-\ufefc]"
  // );

  // var text = message;
  const regexArabic = /[\u0600-\u06FF]+/;
  if (regexArabic.test(message)) return splitSentenceToLines(message, 30);
  return message;
  // arabic = message.split(" ").filter((e) => regex.test(e));
  // english = message.split(" ").filter((e) => !regex.test(e));
  // return `${english.join(" ")} ${arabic.reverse().join("  ")}`;
}
export const fixedArabic=(text)=> {
   if (!text) return "";
   return text.split("").reverse().join("");
};
export function reverseArabicAndEnglish20(message) {
  var regex = new RegExp(
    "[\u0600-\u06ff]|[\u0750-\u077f]|[\ufb50-\ufc3f]|[\ufe70-\ufefc]"
  );

  var arabic = message?.split(" ")?.filter((e) => regex?.test(e));

 var english = message?.split(" ").filter((e) => !regex?.test(e));

  return `${english?.join(" ")} ${arabic?.reverse().join("  ")}`;
}
export function reverseArabicAndEnglish(message) {
  if (!message) return "";

  const regex = /[\u0600-\u06FF\u0750-\u077F]/;

  // تقسيم النص إلى كلمات
  const words = message.split(/\s+/).filter(Boolean);

  const arabic = words.filter(word => regex.test(word));
  const english = words.filter(word => !regex.test(word));

  // حماية الأرقام من الانعكاس داخل PDF
  const protectNumbers = (text) => {
    return text.replace(
      /(\d+(?:[.,]\d+)?)/g,
      "\u200E$1\u200E"
    );
  };

  return `${english.join(" ")} ${arabic.reverse().join(" ")}`
    .trim()
    .replace(/\d+(?:[.,]\d+)?/g, match => `\u200E${match}\u200E`);
}
export function prepareArabicText(testt) {
  
  // if (!text) return"";

  return testt
  .split(/\r?\n/)
  .map(line=>reverseArabicAndEnglish(line))
  .join("\n");
}

export function prepareBillNotes(text,no) {

  if (!text) return "";

  // عدد تقريبي للأحرف في السطر
  const maxChars = no;

  const words = text.trim().split(/\s+/);

  const lines = [];
  let currentLine = "";

  words.forEach(word => {

      const testLine =
          currentLine === ""
              ? word
              : currentLine + " " + word;

      if (testLine.length > maxChars) {

          if (currentLine) {
              lines.push(
                  reverseArabicAndEnglish(currentLine)
              );
          }

          currentLine = word;

      } else {

          currentLine = testLine;
      }
  });

  if (currentLine) {
      lines.push(
          reverseArabicAndEnglish(currentLine)
      );
  }

  return lines.join("\n");
}

export function reverseArabicAndEnglish3(message) {
  if (message===null || message===undefined){
    return "";
  }
  const arabicRegex=/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
  const text=String(message);

  const words=text.split(' ');

  const result=[];
  for (const word of words){
    if(arabicRegex.test(word)){
      result.push(word.split('').reverse().join(''));
    }else{
      result.push(word);
    }
  }
  return result.reverse().join(' ');
}
export function reverseArabicAndEnglish2(message) {
  if (message===null || message===undefined){
    return "";
  }
  const text=String(message);

  const arabicRegex=/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
  const englishRegix=/[A-Za-z]/;
  const numberRegix=/[0-9]/;

  const result=[];
  let current="";
  let currentType=null;

  for (const char of text){
    let type;
    if(arabicRegex.test(char)){
      type="arabic"
    }
    else if(englishRegix.test(char)){
      type="english"
    } else if(numberRegix.test(char)){
      type="number";
    } else{
      type="other"; 
    }

    
  if (
    currentType !==null &&
    type !==currentType&&
    type !=="other"&&
    currentType!=="other"
  ){
    result.push({
      type:currentType,
      text:current
    });
    current="";
  }

  current +=char;
  currentType=type;

  }

  if (current){
    result.push({
      type:currentType,
      text:current
    });
  }

  return result.map(x=>x.text).reverse().join(" ");
}


function detectLang(text) {
  let lang = "ENG";

  if (/[A-Z]|[a-z]/g.test(text)) {
    lang = "ENG";
  }

  if (
    /[ء-ي]/gi.test(text) ||
    /[گچپژیلفقهمو ء-ي]/gi.test(text) ||
    /[\u0600-\u06FF]/gi.test(text)
  ) {
    lang = "ARA";
  }

  if (lang === "ARA") {
    return true;
  } else return false;
}
